import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {CalendarClientInfo} from './model/calendar-client.info';
import {CalendarForm} from './model/calendar.form';
import {CalendarEntry} from './model/calendar.entry';
import {EventEntry} from './model/event.entry';
import {EventForm} from './model/event.form';
import {NewEventResponse} from './model/new-event.response';
import {EventFilter} from './model/event.filter';
import {IdValue} from "../../../core/model/id-value";

@Injectable()
export class CalendarService {

  private eventEditModeSource = new BehaviorSubject<boolean>(false);
  private eventEditMode$ = this.eventEditModeSource.asObservable();

  constructor(private http: HttpClient) {
  }

  public changeEventEditMode(editMode: boolean): void {
    this.eventEditModeSource.next(editMode);
  }

  public eventEditMode(): Observable<boolean> {
    return this.eventEditMode$;
  }

  public getClientInfo(): Observable<CalendarClientInfo> {
    return this.http.get<CalendarClientInfo>('/api/calendar/client-info')
  }

  public getCalendars(type?: string): Observable<IdValue<string>[]> {
    const params = type ? `?type=${type}` : '';
    return this.http.get<IdValue<string>[]>(`/api/calendar/calendars${params}`)
  }

  // -------------------------- CALENDAR --------------------------

  public createCalendar(form: CalendarForm): Observable<CalendarEntry> {
    return this.http.post<CalendarEntry>('/api/calendar', form);
  }

  public updateCalendar(form: CalendarEntry): Observable<void> {
    return this.http.put<void>('/api/calendar', form);
  }

  public deleteCalendar(id: number): Observable<void> {
    return this.http.delete<void>('/api/calendar?id=' + id);
  }

  // -------------------------- EVENT --------------------------

  public getAllCalendarEvents(filter: EventFilter): Observable<EventEntry[]> {
    return this.http.post<EventEntry[]>('/api/calendar/event/all', filter);
  }

  public createEvent(eventForm: EventForm): Observable<NewEventResponse> {
    return this.http.post<NewEventResponse>('/api/calendar/event', eventForm);
  }

  public updateEvent(eventForm: EventForm, id: number): Observable<void> {
    return this.http.put<void>('/api/calendar/event?id=' + id, eventForm);
  }

  public deleteEvent(eventId: number, editRepeating: boolean, recurrenceId: number): Observable<void> {
    return this.http.delete<void>(
      `/api/calendar/event?id=${eventId}&editRepeating=${editRepeating}&recurrenceId=${recurrenceId}`
    );
  }
}
